import React from "react";
import { Accordion, Chip, Group, Radio, Select, Stack, Text, TextInput } from "@mantine/core";
import InfoPopover from "../InfoPopover";
import { AdvancedSettings, EngineSource, TimeControl } from "../models";

interface AdvancedSettingsProps {
    advancedSettings: AdvancedSettings;
    setAdvancedSettings: React.Dispatch<React.SetStateAction<AdvancedSettings>>;
}

const AdvancedSettingsComponent: React.FC<AdvancedSettingsProps> = ({ advancedSettings, setAdvancedSettings }) => {
    return (
        <Accordion mt="md" mb="xl">
            <Accordion.Item value="advanced">
                <Accordion.Control>Advanced</Accordion.Control>
                <Accordion.Panel>
                    <div className={"flex items-center"}>
                        <Radio.Group
                            value={advancedSettings.engineSource}
                            onChange={(value) => {
                                setAdvancedSettings({
                                    ...advancedSettings,
                                    engineSource: value as EngineSource,
                                });
                            }}
                            name="favoriteFramework"
                            label="Select engine source"
                        >
                            <Stack mt="xs">
                                <Radio value="lichess" label="Lichess database" />
                                <Radio value="lichessPlayer" label="Train against a specific player" />
                            </Stack>
                        </Radio.Group>
                    </div>

                    {advancedSettings.engineSource === "lichessPlayer" && (
                        <TextInput
                            mx="xl"
                            mt="sm"
                            label="Lichess username"
                            value={advancedSettings.lichessPlayer}
                            onChange={(e) =>
                                setAdvancedSettings({
                                    ...advancedSettings,
                                    lichessPlayer: e.target.value,
                                })
                            }
                        />
                    )}
                    {advancedSettings.engineSource === "lichessPlayer" && (
                        <>
                            <Text ml="xl" mt="lg">
                                Include games since
                            </Text>
                            <Group justify="left" ml="xl">
                                <Select
                                    w="6rem"
                                    data={[
                                        "2010",
                                        "2011",
                                        "2012",
                                        "2013",
                                        "2014",
                                        "2015",
                                        "2016",
                                        "2017",
                                        "2018",
                                        "2019",
                                        "2020",
                                        "2021",
                                        "2022",
                                        "2024",
                                        "2025",
                                    ]}
                                    value={advancedSettings.sinceYear}
                                    onChange={(value) =>
                                        setAdvancedSettings({
                                            ...advancedSettings,
                                            sinceYear: value as string,
                                        })
                                    }
                                />
                                <Select
                                    w="fit"
                                    data={[
                                        "January",
                                        "February",
                                        "March",
                                        "April",
                                        "May",
                                        "June",
                                        "July",
                                        "August",
                                        "September",
                                        "October",
                                        "November",
                                        "December",
                                    ]}
                                    value={advancedSettings.sinceMonth}
                                    onChange={(value) => {
                                        setAdvancedSettings({
                                            ...advancedSettings,
                                            sinceMonth: value as string,
                                        });
                                    }}
                                />
                                <Group gap="xs" align="center" mt="md">
                                    <Text fz="sm">Time controls</Text>
                                    <InfoPopover text="Pick which time controls to fetch games from the specific player" />
                                </Group>
                                <Chip.Group
                                    multiple={true}
                                    value={advancedSettings.timeControls}
                                    onChange={(value) => {
                                        setAdvancedSettings({
                                            ...advancedSettings,
                                            timeControls: value as TimeControl[],
                                        });
                                    }}
                                >
                                    <Group justify="left">
                                        <Chip value="ultraBullet">Ultrabullet</Chip>
                                        <Chip value="bullet">Bullet</Chip>
                                        <Chip value="blitz">Blitz</Chip>
                                        <Chip value="rapid">Rapid</Chip>
                                        <Chip value="classical">Classical</Chip>
                                        {/* <Chip value="correspondence">Correspondence</Chip> */}
                                    </Group>
                                </Chip.Group>
                            </Group>
                        </>
                    )}
                </Accordion.Panel>
            </Accordion.Item>
        </Accordion>
    );
};

export default AdvancedSettingsComponent;
